import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from "react";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Checkbox } from "primereact/checkbox";
import { Button, Stack, FormGroup, FormControlLabel, FormControl, Checkbox as MUICheckbox, TextField, InputAdornment, IconButton, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
// import CustomerContext from "../../../context/customer/CustomerContext";
import CustomerContext from "../../context/customer/CustomerContext";
//import AuthContext from "../../../context/auth/AuthContext";
import AuthContext from "../../context/auth/AuthContext";
//import ClientFilingMasterContext from "../../../context/client-filing-master/ClientFilingMasterContext";
import ClientFilingMasterContext from "../../context/client-filing-master/ClientFilingMasterContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import { Button as PrimeButton } from "primereact/button";
import CustomDialog from "../common/CustomDialog";
//import Loader from "../../common/Loader";
import Loader from "../common/Loader";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { capitalizeLeadingText } from "../../utils/textFormat";
import { OverlayPanel } from "primereact/overlaypanel";
import { DateTime } from "luxon";
import { Dropdown } from 'primereact/dropdown';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import FilterListIcon from "@mui/icons-material/FilterList";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import ClientTableFilter from "../customer/ClientTableFilter";
import states from "../../data/StateLookup.json"
import axios from "axios";
import { tokens } from "../../theme/tokens";
import { useResponsive } from "../hooks/useResponsive";
import { useCommonDetailsContext } from "../../context/Common/common";
import { TrackNowButton } from "../ui/TrackNowButton";


const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;
const POST_AWARD_DEFERRED_SELECTED_ROW_KEY = "postAwardDeferredSelectedRow";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const persistSelectedDeferredRow = (row) => {
  try {
    if (row) {
      sessionStorage.setItem(
        POST_AWARD_DEFERRED_SELECTED_ROW_KEY,
        JSON.stringify(row)
      );
    } else {
      sessionStorage.removeItem(POST_AWARD_DEFERRED_SELECTED_ROW_KEY);
    }
  } catch (error) {
    // console.log("@@Error storing selected filing tracker record:", error);
  }
};

// const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const AddFilingPostAwardtable = (props) => {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  let { clientId } = useParams();
  const { isMobile, mdUp } = useResponsive();
  const enableForzen = !isMobile
  // const [checked, setChecked] = useState(false);
  // const [FilingMasterList, setMasterFilingList] = useState([]);
  const [_clientId, setClientId] = useState(clientId);
  const [updatedFilingMasterList, setUpdatedFilingMasterList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedMasters, setSelectedMasters] = useState(null);
  const [expandedRows, setExpandedRows] = useState(null);
  const [masterTypeVal, setMasterTypeVal] = useState(false);
  const [clientTypeVal, setClientTypeVal] = useState(false);
  const [isFilingTypeChanged, setIsFilingTypeChanged] = useState(false);
  const [isFilingTypeDisabled, setIsFilingTypeDisabled] = useState(false);
  const [masterCatFilter, setMasterCatFilter] = useState([]);
  const [postawardfederalArray, setPostAwardFederalArray] = useState([]);
  const [postawardstateArray, setPostAwardStateArray] = useState([]);
  const [postawardtypeArray, setPostAwardTypeArray] = useState([]);
  const [postawardagencyArray, setPostAwardAgencyArray] = useState([]);
  const [postawardjsicontactnameArray, setPostAwardJsiContactNameArray] = useState([]);
  const [jurisdiction, setJurisdiction] = useState([]);
  const [masters, setMasters] = useState([]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [selectRows, setSelectRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sortMaster, setSortMaster] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [sortRecord, setSortRecord] = useState("Upcoming Due Dates");
  const [stateArray, setStateArray] = useState([]);
  const [categoryList, setCategoryList] = useState([])
  const [isClearIcon, setIsClearIcon] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);

  const [lazyLoading, setLazyLoading] = useState(false);
  const [refreshRecordList, setRefreshRecordList] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(null);
  const [recordsInView, setRecordsInView] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });
  const lazyLoadInFlightRef = useRef(false);
  const filingListRef = useRef([]);
  const recordsInViewRef = useRef(0);
  const activeLoadRequestRef = useRef("");

  const setRecordsInViewSafe = (nextValue) => {
    setRecordsInView((old) => {
      const next = typeof nextValue === "function" ? nextValue(old) : nextValue;
      recordsInViewRef.current = next;
      return next;
    });
  };

  const setUpdatedFilingMasterListSafe = (nextValue) => {
    setUpdatedFilingMasterList((old) => {
      const next = typeof nextValue === "function" ? nextValue(old) : nextValue;
      filingListRef.current = next;
      return next;
    });
  };

  const createInitialFilters = () => ({

    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    customerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    filingName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    filingFrequency: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    stateList: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    ruleInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    required: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    programNames: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    juristiction: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    postawardPOC: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    awardTypeName: {
      operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    awardingAgencyName: {
      operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    jsicontactName: {
      operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    federalCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    stateCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
  });
  const [filters, setFilters] = useState(createInitialFilters);
  const navigate = useNavigate();
  const customerContext = useContext(CustomerContext);
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const { selectedCustomer } = customerContext;

  const filingMasterContext = useContext(FilingMasterContext);
  const { getBusinessCategories, getProgramName } = filingMasterContext;

  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  // const [showAlertMessage, setShowAlertMessage] = React.useState(false);
  const {
    // getClientFilingMastersForAdd,
    getPostClientFilingMastersForAdd,
    ClientFilingMastersAdd,
    ClientFilingMasterLoaded,
    addPostClientFilingMaster,
  } = clientFilingMasterContext;
  const authContext = useContext(AuthContext);
  const {
    authUser,
    isAuthenticated,
    getCustomerNotifications,
    getFilingNotifications,
    getCustomerNotificationsWorkFlow,
    getAllNotificationCount,
    token,
    setNotificationCount,
  } = authContext;
  const [customerNotificationCount, setCustomerNotificationCount] =
    React.useState(0);
  const [filingNotificationCount, setFilingNotificationCount] =
    React.useState(0);
  const [customerNotificationsWorkFlow, setCustomerNotificationsWorkFlow] =
    React.useState(0);

  const getActiveClientId = () => {
    const resolvedId = props.selectedClientId ?? _clientId ?? clientId;
    if (resolvedId === undefined || resolvedId === null || resolvedId === "") {
      return null;
    }
    return resolvedId;
  };

  const submitDialog = () => {
    if (!selectedMasters?.filingId) return;
    if (selectedMasters.isRejected) {
      setAlertMessage("Do you want to submit this Filing for approval?");
    } else {
      setAlertMessage("Do you want to submit this Filing?");
    }
    setShowAlert(true);
  };

  const fetchNotificationCount = async () => {
    if (
      getAllNotificationCount
    ) {
      try {
        if (token) {
          const res = await getAllNotificationCount(token, authUser?.userId);


          if (setNotificationCount) {
            setNotificationCount(res.totalCount);
          }
        }
      } catch (error) {
        // console.log('@@Error:', error);
      }
    }
  };

  const submitHandler = async () => {
    // [
    //   {

    //     "customerId": 117,
    //     "filingId": 1311,
    //     "notes": "API TEST 2",
    //     "createDate": "2023-04-02T15:36:33.916Z",
    //     "createUser": "eswarans@infinite.com",
    //     "updateDate": "2023-04-02T15:36:33.916Z",
    //     "updateUser": "eswarans@infinite.com",
    //     "businessOperation": "add"
    //   }
    // ]
    // console.log("AuthUSer....", authUser);
    setShowAlert(false);
    setIsLoading(true);
    const activeClientId = getActiveClientId();
    if (!activeClientId) {
      setIsLoading(false);
      setAlertMessage("Please select a valid client.");
      setShowAlert(true);
      return;
    }
    const payLoad = [{
      customerId: activeClientId,
      filingId: selectedMasters.filingId,
      fileTrackingID: selectedMasters.filetrackingID,
      createDate: new Date(),
      createUser: authUser.userId + "",
      updateDate: new Date(),
      updateUser: authUser.userId + "",
      businessOperation: "add",
      status: "Pending",
    }];
    // console.log("Adding Records", payLoad);
    try {
      if (addPostClientFilingMaster) {
        const res = await addPostClientFilingMaster(payLoad);
        // console.log("Result....", res);
        // if (res) {
        setRecordsInViewSafe(0);
        setIsLoading(true);
        setUpdatedFilingMasterListSafe([]);
        setIsFilterChange([]);
        setSortingData({ sortBy: "", sortOrder: "" });
        setMasterCatFilter([]);
        setRefreshRecordList(true);

        // setShowAlert(false);
        // showDialog(
        //   "Success",
        //   "Successfully submitted filings for approval",
        //   "success"
        // );


        if (selectedMasters.isRejected) {
          setDialogMessage("Successfully submitted filings for approval");
        } else {
          setDialogMessage("Successfully submitted and approved the Client Filing. Please check the filing in Tracker page.");
        }
        setDialogTitle("Success");
        setOpenDialog(true);

        persistSelectedDeferredRow(null);
        setSelectedMasters(null);
        await fetchNotificationCount();
        setIsLoading(false);
        // }
      }
    } catch (error) {
      setIsLoading(false);
      setDialogTitle("Error");
      setDialogMessage("Unexpected Error Occurred");
      setOpenDialog(true);
      // showDialog("Error", "Unexpected Error Occured", "error");

      // console.log("Setting Alert to =>", `Unexpected Error Occured`, error);
    }
  };

  // const fetchClientFilingMasters = async (clientId) => {
  //   console.log("@@Fetch Cust Filing Master:", clientId);
  //   // if (clientId) {
  //   // setIsLoading(true);
  //   let payLoad = { customerId: clientId };
  //   if (getPostClientFilingMastersForAdd) {
  //     console.log("@@Fetch Cust Filing Master:");
  //     try {
  //       const custList = await getPostClientFilingMastersForAdd(payLoad);
  //       console.log("@@Cust Filing Master:", custList);
  //     } catch (error) {
  //       console.log("@@Error:", error);
  //     }
  //   }
  //   // }
  // };


  const fetchPostClientFilingMasters = async (clientId) => {
    // console.log("@@Fetch Cust Filing Master:", clientId);
    // if (clientId) {
    // setIsLoading(true);
    // console.log("fetchPostClientFilingMasters ", masterTypeVal, clientTypeVal);
    let filingType
    if (clientTypeVal !== masterTypeVal) {
      filingType = clientTypeVal ? "ClientFiling" : "MasterFiling"
    }
    let payLoad = { customerId: clientId };
    if (getPostClientFilingMastersForAdd) {
      // console.log("@@Fetch Cust Filing Mast:", getPostClientFilingMastersForAdd);
      try {
        const custList = await getPostClientFilingMastersForAdd(payLoad, filingType ? filingType : null);
        // console.log("@@Cust Filing Master:", custList);
      } catch (error) {
        // console.log("@@Error:", error);
      }
    }
    // }
  };

  const onRowSelect = (e) => {
    setSelectRows(e);
    // console.log("@@RowSelect:", e);
    // console.log("@@", selectRows);
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const handleChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  useEffect(() => {
    // console.log("state", selectedRows);
    props.setLoadingFlag(isLoading);
  }, [isLoading]);

  useEffect(() => {
    // console.log("state", selectedRows);
  }, [selectedRows]);

  useEffect(() => {
    if (props.changeSelectedMasters) {
      props.changeSelectedMasters(selectedMasters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMasters]);

  // useEffect(() => {
  //   console.log("####ClientID param", _clientId);
  //   if (clientId !== _clientId) {
  //     fetchClientFilingMasters(_clientId);
  //     setIsLoading(true);
  //     setSelectedMasters([]);
  //   }
  // }, [_clientId]);

  useEffect(() => {
    // console.log("####ClientID param", _clientId, clientId);
    const activeClientId = getActiveClientId();
    if (activeClientId) {
      // fetchPostClientFilingMasters(_clientId);
      persistSelectedDeferredRow(null);
      setSelectedMasters(null);
      setActiveFilters([]);
      setRecordsInViewSafe(0);
      setIsLoading(true);
      setUpdatedFilingMasterListSafe([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setMasterCatFilter([]);
      setRefreshRecordList(true);
      setGlobalFilterValue('');
      setIsClearIcon(false)
      setFilters(createInitialFilters());
      if (search.current) {
        search.current.value = "";
      }
    } else {
      setUpdatedFilingMasterListSafe([])
      persistSelectedDeferredRow(null);
      setSelectedMasters(null);
      setActiveFilters([]);
      setRecordsInViewSafe(0);
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setGlobalFilterValue('');
      setIsClearIcon(false)
      setFilters(createInitialFilters());
      if (search.current) {
        search.current.value = "";
      }
    }
  }, [_clientId]);

  useEffect(() => {
    // console.log("####ClientID param", _clientId, isFilingTypeChanged, clientId);
    const activeClientId = getActiveClientId();
    if (isFilingTypeChanged && activeClientId) {
      if (masterTypeVal === false && clientTypeVal === false) {
        setUpdatedFilingMasterListSafe([])
        setIsFilingTypeChanged(false)
      } else {
        // fetchPostClientFilingMasters(_clientId);
        setRecordsInViewSafe(0);
        setIsLoading(true);
        setUpdatedFilingMasterListSafe([]);
        setIsFilterChange([]);
        setSortingData({ sortBy: "", sortOrder: "" });
        setMasterCatFilter([]);
        setRefreshRecordList(true);
      }
      persistSelectedDeferredRow(null);
      setSelectedMasters(null);
    }
  }, [isFilingTypeChanged]);

  useEffect(() => {
    if (selectedCustomer) {
      // fetchClientFilingMasters(selectedCustomer.customerId);
      // console.log("####Setting ClientID state", selectedCustomer.customerId);
      // setClientId(() => selectedCustomer.customerId);
    }
  }, [selectedCustomer]);

  useEffect(() => {
    // if (props.selectedClientId) {
    // console.log("####Setting ClientID param props", props.selectedClientId);
    if (props.selectedClientId === undefined || props.selectedClientId === null || props.selectedClientId === "") {
      return;
    }
    setClientId(() => props.selectedClientId);
    setClientTypeVal(false)
    setMasterTypeVal(false)
    // }
  }, [props.selectedClientId]);

  useEffect(() => {
    if (clientId !== undefined && clientId !== null && clientId !== "" && clientId !== _clientId) {
      setClientId(() => clientId);
    }
  }, [clientId, _clientId]);

  // useEffect(() => {
  //   // if (clientId) setSelectedClient((old) => clientId);
  //   if (!clientId && !selectedClient) {
  //     fetchClientFilingMasters();
  //   }
  //   //eslint-disable-next-line
  // }, []);

  useEffect(() => {
    // if (ClientFilingMastersAdd) {
    //   let fedLookup = [];
    //   let awardAgencyLookup = [];
    //   let awardTypeLookup = [];
    //   let federalProgramNameLookup = [];
    //   let stateProgramNameLookup = [];
    //   let jsicontactNameLookup = [];
    //   setMasterCatFilter([]);
    //   console.log("Orig Filing List...", ClientFilingMastersAdd);
    //   const updList = ClientFilingMastersAdd.deferredList
    //     ? ClientFilingMastersAdd.deferredList.map((item) => {
    //       console.log(`Customer filing M...`, item);

    //       const programName = item.programInfo && item.programInfo.length > 0

    //         ? item.programInfo[0].programName

    //         : '';

    //       const awardTypeName = item.awardType && item.awardType.length > 0

    //         ? item.awardType[0].awardTypeName

    //         : '';

    //       const awardingAgencyName = item.awardingAgency && item.awardingAgency.length > 0

    //         ? item.awardingAgency[0].awardingAgencyName

    //         : '';

    //       const jsicontactName = item.jsicontactName ? item.jsicontactName : "";

    //       //setPostAwardAwardTypeArray([...postawardawardtypeArray,awardTypeName]);
    //       //setPostAwardAwardingAgencyArray([...postawardawardingagencyArray,awardingAgencyName]);


    //       console.log(`postawardagencyArray.includes`, postawardtypeArray.includes(awardTypeName));
    //       if (!awardTypeLookup.includes(awardTypeName) && awardTypeName !== "") {
    //         console.log(`!postawardtypeArray.includes`, !postawardtypeArray.includes(awardTypeName));
    //         awardTypeLookup.push(awardTypeName)
    //       }
    //       // console.log(`postawardagencyArray`, postawardagencyArray);
    //       if (!jsicontactNameLookup.includes(jsicontactName) && jsicontactName !== "") {
    //         jsicontactNameLookup.push(jsicontactName)
    //       }

    //       if (!awardAgencyLookup.includes(awardingAgencyName) && awardingAgencyName !== "") {
    //         console.log(`!postawardagencyArray.includes`, !postawardagencyArray.includes(awardingAgencyName));
    //         awardAgencyLookup.push(awardingAgencyName)
    //       }


    //       if (item.juristiction?.includes("Federal")) {
    //         // const categories = _.map(
    //         //   item.businessCategory,
    //         //   "businessCategoryName"
    //         // ).join(", ");
    //         console.log(`Customers ${item.filingId} cat...`, programName);

    //         // setPostAwardFederalArray([...postawardfederalArray,programName]);
    //         if (!federalProgramNameLookup.includes(programName) && programName !== "") {
    //           // console.log(`!postawardagencyArray.includes`, !postawardagencyArray.includes(awardingAgencyName));
    //           federalProgramNameLookup.push(programName)
    //         }

    //         return { ...item, federalCategories: programName, awardTypeName, awardingAgencyName, jsicontactName };
    //       } else if (item.juristiction?.includes("Both")) {
    //         // const categories = _.map(
    //         //   item.businessCategory,
    //         //   "businessCategoryName"
    //         // ).join(", ");
    //         console.log(`Customers ${item.filingId} cat...`, programName);

    //         // setPostAwardFederalArray([...postawardfederalArray,programName]);
    //         if (!federalProgramNameLookup.includes(programName) && programName !== "") {
    //           // console.log(`!postawardagencyArray.includes`, !postawardagencyArray.includes(awardingAgencyName));
    //           federalProgramNameLookup.push(programName)
    //         }

    //         if (!stateProgramNameLookup.includes(programName) && programName !== "") {
    //           stateProgramNameLookup.push(programName)
    //         }

    //         return { ...item, federalCategories: programName, stateCategories: programName, awardTypeName, awardingAgencyName, jsicontactName };
    //       } else {
    //         console.log(
    //           "stateCategories: props",
    //           item.stateInfo,
    //           item.businessCategory
    //         );
    //         // const categoriesState = item.businessCategory.filter((ele) =>
    //         //   ele.state ? ele.state === item.stateInfo : ele
    //         // );
    //         // console.log(
    //         //   "stateCategories: filter",
    //         //   item.filingName,
    //         //   categoriesState
    //         // );
    //         // const categories = categoriesState
    //         //   .map((ele) => ele.businessCategoryName)
    //         //   .join(", ");

    //         console.log(`filingMasters ${item.filingMasters} cat...`, programName, awardTypeName, awardingAgencyName, jsicontactName);
    //         // setPostAwardStateArray([...postawardstateArray,programName]);
    //         if (!stateProgramNameLookup.includes(programName) && programName !== "") {
    //           // console.log(`!postawardagencyArray.includes`, !postawardagencyArray.includes(awardingAgencyName));
    //           stateProgramNameLookup.push(programName)
    //         }
    //         // setPostAwardJsiContactNameArray([...postawardjsicontactnameArray,jsicontactName]);
    //         return { ...item, stateCategories: programName, awardTypeName, awardingAgencyName, jsicontactName };
    //       }
    //     })
    //     : [];
    //   console.log("Updated Customers filing M...", updList);
    //   if (clientTypeVal === masterTypeVal) {
    //     setClientTypeVal(ClientFilingMastersAdd.isClientFile)
    //     setMasterTypeVal(ClientFilingMastersAdd.isMasterFile)
    //     if (ClientFilingMastersAdd.isClientFile === true && ClientFilingMastersAdd.isMasterFile === true) {
    //       setIsFilingTypeDisabled(false)
    //     } else {
    //       setIsFilingTypeDisabled(true)
    //     }
    //   }
    //   setIsFilingTypeChanged(false)
    //   // setData(updCustomers);
    //   setUpdatedFilingMasterList(updList);
    //   setPostAwardAgencyArray(awardAgencyLookup);
    //   setPostAwardTypeArray(awardTypeLookup);
    //   setPostAwardFederalArray(federalProgramNameLookup);
    //   setPostAwardStateArray(stateProgramNameLookup);
    //   setPostAwardJsiContactNameArray(jsicontactNameLookup);
    //   setMasters(updList);
    //   setIsLoading(false);
    // }

    //eslint-disable-next-line
  }, [ClientFilingMastersAdd]);

  // useEffect(() => {
  //   return () => {
  //     getClientFilingMastersForAdd({ clientId: 0 });
  //   };
  // }, []);

  const fetchBusinessCategories = async () => {
    // console.log("@@Fetch BusinessCategories:", getProgramName);
    if (getProgramName) {
      // console.log("@@Fetch BusinessCategories:");
      try {
        let list = []
        const progList = await getProgramName();
        // console.log("@@BusinessCategories:", progList);
        list = progList.map((item) => item.programName).sort()
        // console.log("@@BusinessCategories: list", list);
        setCategoryList(() => list);
        return
      } catch (error) {
        // console.log("@@Error:", error);
      }
    }
  };

  useEffect(() => {
    // getPostClientFilingMastersForAdd({ clientId: 0 });
    fetchBusinessCategories()
    let list = states.map((ele) => ele.state);
    setStateArray(list);
  }, []);

  useEffect(() => {
    if (authUser && authUser?.userId) fetchNotificationCount();
  }, [authUser]);

  const footerContent = (
    <div>
      <PrimeButton
        label='No'
        icon='pi pi-times'
        className='p-button-text'
        onClick={() => closeAlert()}
      />
      <PrimeButton
        label='Yes'
        icon='pi pi-check'
        onClick={() => submitHandler()}
        autoFocus
      />
    </div>
  );

  const dialogFooter = (
    <div>
      <PrimeButton
        label='OK'
        icon='pi pi-check'
        onClick={() => setOpenDialog(false)}
        autoFocus
      />
    </div>
  );

  const closeAlert = () => {
    setShowAlert(() => false);
  };

  const handleFilingTypeChange = (type) => {
    // console.log("handleFilingTypeChange", type);
    setIsFilingTypeChanged(true)
    if (type === "master") {
      setMasterTypeVal(!masterTypeVal)
    } else {
      setClientTypeVal(!clientTypeVal)
    }
  };

  const search = useRef()
  const overlayRefs = useRef({});

  const applyGlobalFilter = (e) => {
    // console.log("applyGlobalFilter",e,search);
    let _filters = { ...filters };
    if (filters.global.value === null) {
      _filters["global"].value = search.current.value;
      setIsClearIcon(true);
    } else {
      _filters["global"].value = null;
      search.current.value = ""
      setIsClearIcon(false);
    }
    setFilters(_filters);
    onFilterChange({ filters: _filters });
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const normalizeFilterValueForBackend = (field, value) => {
    if (!Array.isArray(value)) {
      return value;
    }

    const values = value.filter((item) => item !== null && item !== undefined && item !== "");
    if (values.length === 0) {
      return null;
    }

    if (field === "required") {
      if (values.length > 1) {
        return null;
      }
      return values[0];
    }

    if (field === "filingFrequency") {
      return values;
    }

    if (field === "juristiction") {
      if (values.length > 1) {
        return null;
      }
      return values[0];
    }

    return values;
  };

  const handleFilterApply = (filterConfig) => {
    // console.log("Filter applied:", filterConfig);
    const normalizedValue = normalizeFilterValueForBackend(
      filterConfig.field,
      filterConfig.value
    );
    const updatedFilters = activeFilters.filter((f) => f.field !== filterConfig.field);

    if (normalizedValue === null) {
      setActiveFilters(updatedFilters);
      let _filters = { ...filters };
      if (filterConfig.field && _filters[filterConfig.field]) {
        _filters[filterConfig.field].constraints[0].value = null;
        setFilters(_filters);
        onFilterChange({ filters: _filters });
      }
      return;
    }

    const newFilter = {
      ...filterConfig,
      value: normalizedValue,
      displayValue: Array.isArray(normalizedValue) ? normalizedValue : [normalizedValue],
      id: Date.now()
    };
    setActiveFilters([...updatedFilters, newFilter]);

    // Apply filter to table
    let _filters = { ...filters };
    if (filterConfig.field && _filters[filterConfig.field]) {
      _filters[filterConfig.field].constraints[0].value = normalizedValue;
      _filters[filterConfig.field].constraints[0].matchMode = filterConfig.matchMode;
      setFilters(_filters);
      onFilterChange({ filters: _filters });
    }
  };

  const handleFilterClear = () => {
    setActiveFilters([]);
    setFilters(createInitialFilters());
    setMasterCatFilter([]);
    setGlobalFilterValue("");
    setIsClearIcon(false);
    persistSelectedDeferredRow(null);
    setSelectedMasters(null);
    if (search.current) {
      search.current.value = "";
    }
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setUpdatedFilingMasterListSafe([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setRefreshRecordList(true);
  };

  const removeFilter = (filterId) => {
    const filterToRemove = activeFilters.find((filter) => filter.id === filterId);
    const updatedFilters = activeFilters.filter((filter) => filter.id !== filterId);
    setActiveFilters(updatedFilters);

    if (!filterToRemove?.field || !filters[filterToRemove.field]) {
      return;
    }

    let _filters = { ...filters };
    _filters[filterToRemove.field].constraints[0].value = null;
    setFilters(_filters);
    onFilterChange({ filters: _filters });
  };

  const formatFilterLabel = (field) => {
    if (!field) {
      return "";
    }

    const filterLabelMap = {
      filingName: "Filing Name",
      filingFrequency: "Filing Frequency",
      stateList: "State",
      ruleInfo: "Rule Info",
      required: "Required",
      federalCategories: "Who Must File Federal",
      stateCategories: "Who Must File In State",
      jsicontactName: "PostAward POC",
      awardTypeName: "Award Type",
      awardingAgencyName: "Award Agency",
      juristiction: "Jurisdiction",
    };

    if (filterLabelMap[field]) {
      return filterLabelMap[field];
    }

    return field
      .replace(/[_-]+/g, " ")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formatActiveFilterValue = (value) => {
    if (Array.isArray(value)) {
      return value
        .map((item) => (item === true ? "True" : item === false ? "False" : item))
        .join(", ");
    }

    if (value === true) {
      return "True";
    }

    if (value === false) {
      return "False";
    }

    return value;
  };

  const renderHeader = () => {
    return (
      <Grid container spacing={1} sx={{ mb: 2, background: tokens.colors.offWhite, p: 2, px: 1, borderRadius: "8px" }}>

        {/* TITLE */}
        <Grid xs={12} sx={{ display: "flex", alignItems: "center", gap: 1, pl: 2, mb: 1 }}>
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontWeight: 700,
              color: "inherit",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: 1
            }}
          >
            POST AWARD DEFERRED FILINGS ({totalRecords})
          </Typography>
        </Grid>

        {/* MAIN HEADER CONTENT */}
        <Grid
          xs={12}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: 2,
            flexWrap: { xs: "wrap", md: "nowrap" }
          }}
        >

          {/* LEFT SIDE : FILTER + CHIPS */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              alignItems: "flex-start",
              gap: 2,
              width: { xs: "100%", md: "auto" },
              minWidth: 0
            }}
          >
            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={handleFilterClick}
            >
              + Filter
            </TrackNowButton>

            {activeFilters.length > 0 && (
              <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
                {activeFilters.map((filter) => (
                  <div
                    key={filter.id}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: tokens.colors.offWhite,
                      border: "1px solid #ccc",
                      borderRadius: "20px",
                      padding: "6px 12px",
                      fontSize: "13px",
                      color: "#333"
                    }}
                  >
                    <span>
                      {formatFilterLabel(filter.field)}:{" "}
                      {formatActiveFilterValue(filter.value)}
                    </span>

                    <button
                      onClick={() => removeFilter(filter.id)}
                      style={{
                        marginLeft: "6px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#666",
                        fontSize: "16px"
                      }}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </Box>
            )}
          </Box>

          {/* RIGHT SIDE : CHECKBOX + SEARCH + SUBMIT */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "stretch", sm: "center" },
              gap: 2,
              width: { xs: "100%", md: "auto" },
              minWidth: 0
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <FormControlLabel
                control={
                  <MUICheckbox
                    checked={masterTypeVal}
                    disabled={isFilingTypeDisabled}
                    onClick={() => handleFilingTypeChange("master")}
                    sx={{
                      color: primaryColor,
                      '&.Mui-checked': { color: primaryColor },
                      padding: '4px'
                    }}
                  />
                }
                label={<span style={{ color: masterTypeVal ? "#4a4a4a" : "#9ca3af", fontWeight: 500, fontSize: '15px' }}>Master Filing</span>}

                sx={{ margin: 0 }}
              />

              <FormControlLabel
                control={
                  <MUICheckbox
                    checked={clientTypeVal}
                    disabled={isFilingTypeDisabled}
                    onClick={() => handleFilingTypeChange("client")}
                    sx={{
                      color: primaryColor,
                      '&.Mui-checked': { color: primaryColor },
                      padding: '4px'
                    }}
                  />
                }
                label={<span style={{ color: clientTypeVal ? "#4a4a4a" : "#9ca3af", fontWeight: 500, fontSize: '15px' }}>Client Filing</span>}

                sx={{ margin: 0 }}
              />
            </Box>

            <TextField
              inputRef={search}
              placeholder="Search Filing Name..."
              size="small"
              sx={{
                width: { xs: "100%", sm: 280 },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "999px",
                  backgroundColor: tokens.colors.offWhite,
                  fontFamily: "Area Normal, Inter, sans-serif",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0, 0, 0, 0.23)",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${primaryColor} !important`,
                  borderWidth: "1px !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${primaryColor} !important`,
                  borderWidth: "1px !important",
                },
                "& .MuiInputBase-input": {
                  py: "11px",
                  px: "14px",
                  fontSize: "15px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={applyGlobalFilter}
                      edge="end"
                      size="small"
                    >
                      {isClearIcon ? (
                        <ClearIcon sx={{ color: primaryColor }} />
                      ) : (
                        <SearchIcon sx={{ color: primaryColor }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={submitDialog}
              disabled={!selectedMasters?.filingId}
            >
              Submit
            </TrackNowButton>
          </Box>
        </Grid>
      </Grid>
    );
  };

  //const header = renderHeader();





  const cellListDisplayName = (rowData) => {
    return (
      <LightTooltip title={rowData.filingName} placement="bottom">
        <div
          onClick={() => {
            persistSelectedDeferredRow(rowData);
            setSelectedMasters(rowData);
            props.changeSelectedMasters(rowData);
          }}
          style={{
            width: "12rem",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: primaryColor,
            cursor: "pointer",
            transition: "font-weight 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.fontWeight = '600';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.fontWeight = '400';
          }}
        >
          {rowData.filingName}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayRuleInfo = (rowData) => {
    const ruleInfoValue = capitalizeLeadingText(rowData.ruleInfo);
    return (
      <LightTooltip title={ruleInfoValue} placement="bottom">
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        >
          {ruleInfoValue}
        </div>
      </LightTooltip>
    );
  };

  const cellWithTooltip = (rowData, field) => {
    const rawValue = rowData?.[field];
    const displayValue =
      typeof rawValue === "boolean"
        ? rawValue
          ? "True"
          : "False"
        : rawValue ?? "";

    return (
      <LightTooltip title={displayValue} placement="bottom">
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        >
          {displayValue}
        </div>
      </LightTooltip>
    );
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#F1F2F6",
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));

  const CellListDisplayFederal = (rowData, field) => {
    //console.log("CellListDisplayFederal", field, rowData.filingName, rowData);

    const businessCategories = Array.isArray(rowData.businessCategory) ? rowData.businessCategory : [];
    const rawValue = rowData[field] || "";
    const fallbackList =
      typeof rawValue === "string" && rawValue.length > 0
        ? rawValue.split(",").map((item) => item.trim()).filter(Boolean)
        : [];
    const categories = rowData[field]
      ? field === "federalCategories"
        ? businessCategories.map((ele) => ele.businessCategoryName)
        : businessCategories
          .filter((ele) => ele.state === rowData.stateInfo)
          .map((ele) => ele.businessCategoryName)
      : fallbackList;
    const displayValue = categories[0] || rawValue || "";
    const remainingCount = Math.max(categories.length - 1, 0);
    const hasValue = categories.length > 0;
    const hasMore = categories.length > 1;
    //console.log("CellListDisplayFederal categories--", categories);

    let name =
      field === "federalCategories"
        ? "Who Must File Federal"
        : "Who Must File in State";
    const overlayKey = `${field}-${rowData.filingId || rowData.fileTrackingId}`;

    const hideOtherCellOverlays = (currentKey) => {
      Object.entries(overlayRefs.current).forEach(([key, overlay]) => {
        if (key !== currentKey && overlay?.hide) {
          overlay.hide();
        }
      });
    };

    const getPreferredOverlayDirection = (cellElement) => {
      const rowElement = cellElement?.closest("tr");
      const rowIndexAttr = rowElement?.getAttribute("data-p-index");
      const rowIndex = rowIndexAttr !== null ? Number(rowIndexAttr) : -1;
      if (rowIndex >= 0 && rowIndex <= 2) {
        return "down";
      }

      const cellRect = cellElement?.getBoundingClientRect();
      if (!cellRect) {
        return "down";
      }

      return cellRect.bottom > window.innerHeight * 0.7 ? "up" : "down";
    };

    const positionOverlayNearCell = (cellElement, preferredDirection) => {
      const overlayPanel = overlayRefs.current[overlayKey];
      const overlayElement = overlayPanel?.container;
      if (!overlayElement || !cellElement || overlayElement.style.display === "none") {
        return;
      }

      const cellRect = cellElement.getBoundingClientRect();
      const overlayRect = overlayElement.getBoundingClientRect();
      const gap = 8;
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      const canOpenDown = cellRect.bottom + overlayRect.height + gap <= viewportHeight;
      const canOpenUp = cellRect.top - overlayRect.height - gap >= gap;

      let openUp = false;
      if (preferredDirection === "up" && canOpenUp) {
        openUp = true;
      } else if (preferredDirection === "down" && !canOpenDown && canOpenUp) {
        openUp = true;
      } else if (!canOpenDown && canOpenUp) {
        openUp = true;
      }

      let top = openUp
        ? cellRect.top - overlayRect.height - gap
        : cellRect.bottom + gap;
      let left = cellRect.left + cellRect.width / 2 - overlayRect.width / 2;

      left = Math.min(Math.max(left, gap), viewportWidth - overlayRect.width - gap);
      top = Math.min(Math.max(top, gap), viewportHeight - overlayRect.height - gap);

      overlayElement.style.position = "fixed";
      overlayElement.style.left = `${Math.round(left)}px`;
      overlayElement.style.top = `${Math.round(top)}px`;
      overlayElement.style.transform = "none";
    };

    const toggleCellOverlay = (event) => {
      event.stopPropagation();
      event.preventDefault();
      const targetElement = event.currentTarget;

      const overlayPanel = overlayRefs.current[overlayKey];
      if (!overlayPanel?.toggle) return;

      const overlayElement = overlayPanel.container;
      const isVisible = Boolean(
        overlayElement && overlayElement.style.display !== "none"
      );

      if (!isVisible) {
        hideOtherCellOverlays(overlayKey);
      }

      overlayPanel.toggle(event);

      requestAnimationFrame(() => {
        const preferredDirection = getPreferredOverlayDirection(targetElement);
        positionOverlayNearCell(targetElement, preferredDirection);
      });
    };

    return (
      <div className='tableBtn' id={`${field}+${rowData.fileTrackingId}`}>
        <PrimeButton
          onClick={(event) => {
            if (!hasValue) return;
            toggleCellOverlay(event);
          }}
          text
          style={{ width: "100%" }}
        >
          <div
            style={{
              width: "100%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              whiteSpace: "nowrap",
              minWidth: 0,
            }}
          >
            <LightTooltip title={displayValue} placement="bottom">
              <span
                style={{
                  flex: "1 1 auto",
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  color: "#432568",
                  cursor: hasValue ? "pointer" : "default",
                  textAlign: "left",
                }}
              >
                {displayValue}
              </span>
            </LightTooltip>
            {hasMore && (
              <span
                className="deferred-more-count"
                style={{
                  fontSize: "12px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                {`+${remainingCount} more`}
              </span>
            )}
          </div>
        </PrimeButton>
        {hasValue && (
          <OverlayPanel
            ref={(el) => {
              if (el) {
                overlayRefs.current[overlayKey] = el;
              }
            }}
            showCloseIcon
            className="deferred-categories-overlay"
            dismissable
            style={{
              padding: "0.4rem 0.8rem",
              width: "min(22rem, calc(100vw - 1rem))",
              maxWidth: "min(22rem, calc(100vw - 1rem))",
              maxHeight: "min(18rem, calc(100vh - 1rem))",
            }}
          >
            {name}
            <div className="overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
              {categories.length > 0 ? (
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                  {categories.map((ele, idx) => (
                    <li key={`${field}-${idx}`} style={{ marginBottom: "4px", overflowWrap: "anywhere" }}>{ele}</li>
                  ))}
                </ul>
              ) : (
                <div>{displayValue}</div>
              )}
            </div>
          </OverlayPanel>
        )}
      </div>
    );
  };

  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yy");
      //  console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };
  const toLocalTime2 = (date) => {
    // console.log("toLocalTime", date);
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-LL-yyyy hh:mm:ss"),
        "dd-LL-yyyy hh:mm:ss",
        { zone: "UTC" }
      ).toFormat("yyyy-LL-dd");
      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };


  const jusrisdictionItemTemplate = (option) => {
    // console.log("##TOptions:", option);
    return (
      <div className="flex align-items-center">
        <span>{option}</span>
      </div>
    );
  };


  const postawardFederalRowFilterTemplate = (options) => {
    // console.log(" postawardFederalRowFilterTemplate:", options, postawardfederalArray);
    return (
      <MultiSelect
        value={masterCatFilter.federalCategories || []}
        options={postawardfederalArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardFederalRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, federalCategories: e.value };
          });
          options.filterApplyCallback(e.value);
          //options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };

  const postawardStateRowFilterTemplate = (options) => {
    // console.log(" postawardStateRowFilterTemplate:", options, postawardstateArray);
    return (
      <MultiSelect
        value={masterCatFilter.stateCategories || []}
        options={postawardstateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log(" postawardStateRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, stateCategories: e.value };
          });
          options.filterApplyCallback(e.value);
          //options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };


  const postawardAwardtypeRowFilterTemplate = (options) => {
    // console.log("  postawardAwardtypeRowFilterTemplate:", options, postawardtypeArray);
    return options.filterModel.matchMode === 'in' ? (
      <MultiSelect
        value={masterCatFilter.awardTypeName || []}
        options={postawardtypeArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, awardTypeName: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.awardTypeName || []}
        options={postawardtypeArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, awardTypeName: e.value };
          });
          let values = [];
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder='Any'
        maxSelectedLabels={1}
        className='p-column-filter'
        style={{ minWidth: '12rem', maxWidth: '13rem' }}
      />
    );
  };

  const postawardAwardingagencyRowFilterTemplate = (options) => {
    // console.log("  postawardAwardingagencyRowFilterTemplate:", options, postawardagencyArray);
    return options.filterModel.matchMode === 'in' ? (
      <MultiSelect
        value={masterCatFilter.awardingAgencyName || []}
        options={postawardagencyArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, awardingAgencyName: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.awardingAgencyName || []}
        options={postawardagencyArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, awardingAgencyName: e.value };
          });
          let values = [];
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder='Any'
        maxSelectedLabels={1}
        className='p-column-filter'
        style={{ minWidth: '12rem', maxWidth: '13rem' }}
      />
    );
  };



  const postawardContactNameRowFilterTemplate = (options) => {
    // console.log("postawardContactNameRowFilterTemplate:", options, postawardjsicontactnameArray);
    return (
      <MultiSelect
        value={masterCatFilter.jsicontactName || []}
        options={postawardjsicontactnameArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("postawardContactNameRowFilterTemplate:", e.value, masters);
          setMasterCatFilter((prev) => {
            return { ...prev, jsicontactName: e.value };
          });
          options.filterApplyCallback(e.value);
          //options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };
  // const rowExpansionTemplate = (data) => {
  //   console.log("rowExpansionTemplate", data.filingPeriods);
  //   if (data.filingPeriods.length > 0) {
  //     let tableData = data.filingPeriods.map((ele) => {
  //       let fp = `${toLocalTime(ele.startDate)} - ${toLocalTime(ele.endDate)}`;
  //       return {
  //         startDate: ele.startDate,
  //         endDate: ele.endDate,
  //         filingPeriod: fp,
  //         dueDate: toLocalTime(ele.dueDate),
  //       };
  //     });
  //     return (
  //       <div className="filingPeriodTable p-3" style={{ width: "50vw" }}>
  //         <h5>Due Dates for {data.filingName}</h5>
  //         <DataTable value={tableData}>
  //           <Column field="filingPeriod" header="Filing Period"></Column>
  //           <Column field="dueDate" header="DueDate"></Column>
  //         </DataTable>
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div className="filingPeriodTable p-3">
  //         <h5>No Due Dates for {data.filingName}</h5>
  //       </div>
  //     );
  //   }
  // };
  const rowExpand = (event) => {
    // console.log("rowExpand", event, expandedRows);
    setExpandedRows(event.data);
  };

  const jusrisdictionArray = ["Federal", "State", "Both"];

  const jurisdictionRowFilterTemplate = (options) => {
    // console.log("jurisdictionRowFilterTemplate props", options,masterCatFilter);

    if (!masterCatFilter.jurisdiction && options.filterModel.value) {
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={masterCatFilter.jurisdiction || []}
        options={jusrisdictionArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setMasterCatFilter((prev) => {
            return { ...prev, jurisdiction: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const requiredArray = ["True", "False"];

  const requiredRowFilterTemplate = (options) => {
    // console.log("requiredRowFilterTemplate:", options,masterCatFilter);
    if (!masterCatFilter.required && options.filterModel.value) {
      options.filterModel.value = null;
      options.value = null;
    }
    return (
      <Dropdown
        value={masterCatFilter.required || []}
        options={requiredArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, required: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const masterCategoryFilter = (options, field) => {
    // console.log("OPTIONCHECK", options, "field", field);
    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={masterCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const stateRowFilterTemplate = (options) => {
    if (!masterCatFilter.stateList && options.filterModel.value) {
      options.filterModel.value = [];
      options.value = [];
    }
    return options.filterModel.matchMode === "contains" ? (
      <MultiSelect
        value={masterCatFilter.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, stateList: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "12rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, stateList: e.value };
          });
          let values = [];
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "12rem" }}
      />
    );
  };

  const dt = useRef(null);
  const pageSize = 100;

  // lazy load function
  const loadDataLazy = async (event) => {
    // console.log("loadDataLazy props", recordsInViewRef.current, event);

    if (lazyLoadInFlightRef.current || lazyLoading) {
      return;
    }

    //Virtual scroll callback
    const vScroll = dt.current?.getVirtualScroller?.()
    if (!vScroll?.getRenderedRange) {
      return;
    }

    let range = vScroll.getRenderedRange();
    if (!range?.viewport) {
      return;
    }
    let { first, last } = range.viewport;
    // console.log("loadDataLazy vScroll", vScroll, range.viewport);

    const firstVal = recordsInViewRef.current * pageSize;
    const tableList = filingListRef.current;
    const edgeThreshold = 10;
    const isNearBottom = last >= tableList.length - edgeThreshold;
    const isNearTop = first <= edgeThreshold;
    const previousWindowStart = (recordsInViewRef.current - 3) * pageSize;
    const canLoadPreviousPage =
      recordsInViewRef.current > 2 && previousWindowStart >= 0;
    // console.log(
    //   "loadDataLazy totalRecords",
    //   firstVal,
    //   totalRecords,
    //   lazyLoading,
    //   tableList.length
    // );

    // console.log(
    //   "loadDataLazy",
    //   firstVal < totalRecords,
    //   first > tableList.length - 10,
    //   !lazyLoading
    // );

    if (
      firstVal < totalRecords &&
      isNearBottom &&
      !lazyLoading
    ) {
      //scroll down
      lazyLoadInFlightRef.current = true;
      setLazyLoading(true);
      const lastVal = Math.min(firstVal + pageSize, totalRecords);
      // console.log("loadDataLazy d firstVal", firstVal, lastVal);

      //get next data
      try {
        const records = await loadRecordsList(firstVal, lastVal, "down");
        // console.log("loadDataLazy d record", records);
        if (Array.isArray(records) && records.length > 0) {
          // console.log("loadDataLazy d scrollInView", recordsInViewRef.current * pageSize);

          //scroll to next records
          if (typeof vScroll.scrollInView === "function") {
            vScroll.scrollInView(recordsInViewRef.current * pageSize);
          } else if (typeof vScroll.scrollToIndex === "function") {
            vScroll.scrollToIndex(recordsInViewRef.current * pageSize);
          }
          setRecordsInViewSafe((old) => old + 1);
        }
      } finally {
        setLazyLoading(false);
        setIsLoading(false);
        lazyLoadInFlightRef.current = false;
      }
    } else if (isNearTop && canLoadPreviousPage && !lazyLoading) {
      // scroll up
      const previousWindowEnd = Math.min(
        previousWindowStart + pageSize,
        totalRecords
      );
      lazyLoadInFlightRef.current = true;
      setLazyLoading(true);
      try {
        //get prev data
        const records = await loadRecordsList(
          previousWindowStart,
          previousWindowEnd,
          "up"
        );
        // console.log("loadDataLazy u record", records);
        if (Array.isArray(records) && records.length > 0) {
          //scroll to prev records
          if (typeof vScroll.scrollToIndex === "function") {
            vScroll.scrollToIndex(pageSize);
          } else if (typeof vScroll.scrollInView === "function") {
            vScroll.scrollInView(pageSize);
          }
          setRecordsInViewSafe((old) => old - 1);
        }
      } finally {
        setLazyLoading(false);
        setIsLoading(false);
        lazyLoadInFlightRef.current = false;
      }
    }
  };

  const loadRecordsList = async (first, last, direction) => {
    // console.log("loadRecordsList props", first, last, direction);
    setIsLoading(true);
    const activeClientId = getActiveClientId();
    if (!activeClientId) {
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      return [];
    }

    const requestKey = [
      activeClientId,
      first,
      last,
      direction,
      clientTypeVal !== masterTypeVal && !isFilingTypeDisabled
        ? clientTypeVal ? "ClientFiling" : "MasterFiling"
        : "",
      sortingData?.sortBy ?? "",
      sortingData?.sortOrder ?? "",
      JSON.stringify(isFilterChange ?? []),
      JSON.stringify(activeFilters ?? []),
    ].join("|");

    if (activeLoadRequestRef.current) {
      return [];
    }

    activeLoadRequestRef.current = requestKey;

    const buildBaseUrl = (startRow, endRow) => {
      let baseUrl = `${API_BASE_URL}/Customer/PostawardBusinessBasedFilingMasterListByPagination?StartRow=${startRow + 1}&EndRow=${endRow}&CustomerId=${activeClientId}`;
      let filingType;
      if (clientTypeVal !== masterTypeVal && !isFilingTypeDisabled) {
        filingType = clientTypeVal ? "ClientFiling" : "MasterFiling";
      }
      if (filingType) {
        baseUrl = `${baseUrl}&FilingType=${filingType}`;
      }
      return baseUrl;
    };

    const appendFiltersToUrl = (baseUrl, filters) => {
      let updatedUrl = baseUrl;
      filters.forEach((ele) => {
        const filterName = encodeURIComponent(ele.name);
        const filterValue = encodeURIComponent(ele.val);
        const searchType = ele.searchType ? encodeURIComponent(ele.searchType) : "";
        const searchTypeVal = ele.searchTypeVal ? encodeURIComponent(ele.searchTypeVal) : "";
        updatedUrl = `${updatedUrl}&${filterName}=${filterValue}${ele.searchType ? `&${searchType}=${searchTypeVal}` : ``}`;
      });
      return updatedUrl;
    };

    const appendSortToUrl = (baseUrl) => {
      let updatedUrl = baseUrl;
      if (
        sortingData &&
        typeof sortingData === "object" &&
        sortingData.sortBy !== "" &&
        sortingData.sortOrder !== ""
      ) {
        let sortParameter = getSortData(sortingData.sortBy);
        let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";
        updatedUrl = `${updatedUrl}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
      }
      return updatedUrl;
    };

    const allFilters = (isFilterChange !== undefined && isFilterChange.length > 0 ? isFilterChange : []).map((filter) => {
      if (filter.name === "SearchByfilingFrequency") {
        return {
          ...filter,
          searchType: "filingFrequencySearchType",
          searchTypeVal: filter.searchTypeVal || "EqualTo",
        };
      }
      return filter;
    });

    const normalizeRequiredToken = (value) => {
      if (value === true) return "true";
      if (value === false) return "false";
      if (value === null || value === undefined) return null;
      const token = value.toString().trim().toLowerCase();
      if (token === "true") return "true";
      if (token === "false") return "false";
      if (token === "yes") return "true";
      if (token === "no") return "false";
      if (token === "y") return "true";
      if (token === "n") return "false";
      if (token === "1") return "true";
      if (token === "0") return "false";
      return null;
    };

    const extractFirstValue = (value) => {
      if (!Array.isArray(value)) {
        return value;
      }
      const firstNonEmpty = value.find((item) => item !== null && item !== undefined && item !== "");
      return firstNonEmpty ?? null;
    };

    const isLocalFilterName = (name) => {
      const token = (name ?? "").toString().trim().toLowerCase();
      return (
        token === "searchbyjsistaff" ||
        token === "searchbyrequired" ||
        token === "whomustfilefederal" ||
        token === "whomustfileinstate"
      );
    };

    const jsiStaffFilters = allFilters.filter(
      (filter) => (filter?.name ?? "").toString().trim().toLowerCase() === "searchbyjsistaff"
    );
    const requiredFilters = allFilters.filter(
      (filter) => (filter?.name ?? "").toString().trim().toLowerCase() === "searchbyrequired"
    );
    const requiredFallbackFromActiveFilters =
      requiredFilters.length === 0
        ? activeFilters
          .filter((filter) => filter?.field === "required")
          .map((filter) => ({
            name: "SearchByRequired",
            val: extractFirstValue(filter?.value),
            searchTypeVal: "EqualTo",
          }))
          .filter((filter) => filter.val !== null && filter.val !== undefined && filter.val !== "")
        : [];

    const effectiveRequiredFilters = requiredFilters.length > 0 ? requiredFilters : requiredFallbackFromActiveFilters;
    const remoteFilters = allFilters.filter((filter) => !isLocalFilterName(filter?.name));
    const stateFilters = allFilters.filter((filter) => {
      const token = (filter?.name ?? "").toString().trim().toLowerCase();
      return token === "searchbystateinfo" || token === "searchbystate";
    });
    const federalCategoryFilters = allFilters.filter(
      (filter) => (filter?.name ?? "").toString().trim().toLowerCase() === "whomustfilefederal"
    );
    const stateCategoryFilters = allFilters.filter(
      (filter) => (filter?.name ?? "").toString().trim().toLowerCase() === "whomustfileinstate"
    );

    const getDerivedFederalCategories = (item) => {
      const businessCategories = Array.isArray(item?.businessCategory) ? item.businessCategory : [];
      const federalCategoryNames = businessCategories
        .map((category) => category?.businessCategoryName?.toString().trim())
        .filter(Boolean);
      const programName = item?.programInfo && item.programInfo.length > 0
        ? item.programInfo[0]?.programName?.toString().trim()
        : "";
      const fallbackNames = programName ? [programName] : [];
      return Array.from(new Set([...(federalCategoryNames.length > 0 ? federalCategoryNames : []), ...fallbackNames]))
        .filter(Boolean)
        .map((value) => value.toLowerCase());
    };

    const getDerivedStateCategories = (item) => {
      const businessCategories = Array.isArray(item?.businessCategory) ? item.businessCategory : [];
      const stateCategoryNames = businessCategories
        .filter((category) => category?.state === item?.stateInfo)
        .map((category) => category?.businessCategoryName?.toString().trim())
        .filter(Boolean);
      const programName = item?.programInfo && item.programInfo.length > 0
        ? item.programInfo[0]?.programName?.toString().trim()
        : "";
      const fallbackNames = programName ? [programName] : [];
      return Array.from(new Set([...(stateCategoryNames.length > 0 ? stateCategoryNames : []), ...fallbackNames]))
        .filter(Boolean)
        .map((value) => value.toLowerCase());
    };

    const applyClientSideFilters = (items) => {
      let filteredItems = Array.isArray(items) ? items : [];

      if (stateFilters.length > 0) {
        const normalizedStateFilters = stateFilters
          .map((filter) => ({
            value: filter?.val?.toString().trim().toLowerCase(),
            mode: (filter?.searchTypeVal || "Contains").toLowerCase(),
          }))
          .filter((filter) => filter.value);

        const containsStateFilters = normalizedStateFilters.filter(
          (filter) => filter.mode === "contains"
        );
        const equalsStateFilters = normalizedStateFilters.filter(
          (filter) => filter.mode === "equalto"
        );
        const notContainsStateFilters = normalizedStateFilters.filter(
          (filter) => filter.mode === "notcontains"
        );

        if (containsStateFilters.length > 0) {
          const allowedStates = new Set(containsStateFilters.map((filter) => filter.value));
          filteredItems = filteredItems.filter((item) => {
            const itemStateCode = (item?.stateInfo ?? "").toString().trim().toLowerCase();
            const itemStateName = (getStateName(item?.stateInfo) ?? "").toString().trim().toLowerCase();
            return allowedStates.has(itemStateCode) || allowedStates.has(itemStateName);
          });
        }

        if (equalsStateFilters.length > 0) {
          const allowedStates = new Set(equalsStateFilters.map((filter) => filter.value));
          filteredItems = filteredItems.filter((item) => {
            const itemStateCode = (item?.stateInfo ?? "").toString().trim().toLowerCase();
            const itemStateName = (getStateName(item?.stateInfo) ?? "").toString().trim().toLowerCase();
            return allowedStates.has(itemStateCode) || allowedStates.has(itemStateName);
          });
        }

        if (notContainsStateFilters.length > 0) {
          const excludedStates = new Set(notContainsStateFilters.map((filter) => filter.value));
          filteredItems = filteredItems.filter((item) => {
            const itemStateCode = (item?.stateInfo ?? "").toString().trim().toLowerCase();
            const itemStateName = (getStateName(item?.stateInfo) ?? "").toString().trim().toLowerCase();
            return !excludedStates.has(itemStateCode) && !excludedStates.has(itemStateName);
          });
        }
      }

      // PostAward POC: force case-insensitive text matching.
      jsiStaffFilters.forEach((filter) => {
        const rawFilterText = filter?.val?.toString().trim();
        if (!rawFilterText) return;
        const filterText = rawFilterText.toLowerCase();
        const mode = (filter?.searchTypeVal || "Contains").toLowerCase();

        filteredItems = filteredItems.filter((item) => {
          const sourceText = (item?.jsicontactName ?? "").toString().trim().toLowerCase();
          if (mode === "equalto") {
            return sourceText === filterText;
          }
          if (mode === "notcontains") {
            return !sourceText.includes(filterText);
          }
          return sourceText.includes(filterText);
        });
      });

      // Required: strict true/false only. Blank/null values are excluded when filter is active.
      effectiveRequiredFilters.forEach((filter) => {
        const expected = normalizeRequiredToken(extractFirstValue(filter?.val));
        if (!expected) return;
        const mode = (filter?.searchTypeVal || "Contains").toLowerCase();

        filteredItems = filteredItems.filter((item) => {
          const actual = normalizeRequiredToken(item?.required);
          if (actual === null) return false;
          if (mode === "notcontains") {
            return actual !== expected;
          }
          return actual === expected;
        });
      });

      federalCategoryFilters.forEach((filter) => {
        const rawFilterValue = extractFirstValue(filter?.val)?.toString().trim();
        if (!rawFilterValue) return;
        const expected = rawFilterValue.toLowerCase();
        const mode = (filter?.searchTypeVal || "Contains").toLowerCase();

        filteredItems = filteredItems.filter((item) => {
          const categories = getDerivedFederalCategories(item);
          const isMatch = categories.includes(expected);

          if (mode === "equalto") {
            return isMatch;
          }
          if (mode === "notcontains") {
            return !isMatch;
          }
          return categories.some((category) => category.includes(expected));
        });
      });

      stateCategoryFilters.forEach((filter) => {
        const rawFilterValue = extractFirstValue(filter?.val)?.toString().trim();
        if (!rawFilterValue) return;
        const expected = rawFilterValue.toLowerCase();
        const mode = (filter?.searchTypeVal || "Contains").toLowerCase();

        filteredItems = filteredItems.filter((item) => {
          const categories = getDerivedStateCategories(item);
          const isMatch = categories.includes(expected);

          if (mode === "equalto") {
            return isMatch;
          }
          if (mode === "notcontains") {
            return !isMatch;
          }
          return categories.some((category) => category.includes(expected));
        });
      });

      return filteredItems;
    };

    const frequencyFilters = allFilters.filter((filter) => filter.name === "SearchByfilingFrequency");
    const hasMultiFrequency = frequencyFilters.length > 1;
    const hasLocalClientFilters =
      jsiStaffFilters.length > 0 ||
      effectiveRequiredFilters.length > 0 ||
      stateFilters.length > 0 ||
      federalCategoryFilters.length > 0 ||
      stateCategoryFilters.length > 0;
    const shouldUseBulkFiltering = hasMultiFrequency || hasLocalClientFilters;
    const normalizeFrequencyToken = (value) =>
      (value ?? "")
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[\s\-_]+/g, "");
    const selectedFrequencyTokens = new Set(
      frequencyFilters
        .map((filter) => normalizeFrequencyToken(filter.val))
        .filter(Boolean)
    );
    const isSelectedFrequency = (item) => {
      if (selectedFrequencyTokens.size === 0) {
        return true;
      }
      const recordFrequency = item?.filingFrequency;
      if (!recordFrequency) {
        return false;
      }
      const itemTokens = recordFrequency
        .toString()
        .split(/[,/|]/)
        .map((token) => normalizeFrequencyToken(token))
        .filter(Boolean);
      if (itemTokens.length === 0) {
        return false;
      }
      return itemTokens.some((token) => selectedFrequencyTokens.has(token));
    };

    try {
      if (shouldUseBulkFiltering) {
        const nonFrequencyFilters = remoteFilters.filter(
          (filter) => filter.name !== "SearchByfilingFrequency"
        );
        let bulkFetchUrl = buildBaseUrl(0, 10000);
        bulkFetchUrl = appendFiltersToUrl(bulkFetchUrl, nonFrequencyFilters);
        bulkFetchUrl = appendSortToUrl(bulkFetchUrl);

        let responses = [];
        if (hasMultiFrequency) {
          const uniqueFrequencies = Array.from(
            new Set(
              frequencyFilters
                .map((filter) => filter.val)
                .filter((value) => value !== null && value !== undefined && value !== "")
            )
          );

          responses = await Promise.all(
            uniqueFrequencies.map((frequency) => {
              const requestUrl = appendFiltersToUrl(bulkFetchUrl, [
                {
                  name: "SearchByfilingFrequency",
                  val: frequency,
                  searchType: "filingFrequencySearchType",
                  searchTypeVal: "EqualTo",
                },
              ]);
              return axios.get(requestUrl);
            })
          );
        } else {
          responses = [await axios.get(bulkFetchUrl)];
        }

        const mergedMap = new Map();
        responses.forEach((response) => {
          const items = (response?.data?.items || []).filter((item) =>
            isSelectedFrequency(item)
          );
          items.forEach((item) => {
            const key = item.filetrackingID ?? item.filingId ?? item.masterId ?? `${item.filingName}-${item.stateInfo}-${item.juristiction}`;
            if (!mergedMap.has(key)) {
              mergedMap.set(key, item);
            }
          });
        });

        const mergedItems = Array.from(mergedMap.values());
        const locallyFilteredItems = applyClientSideFilters(mergedItems);
        const pagedItems = locallyFilteredItems.slice(first, last);

        let ogList = updatedFilingMasterList.map((ele) => ele);
        await modifyList(pagedItems, direction, ogList);
        setTotalRecords(locallyFilteredItems.length);
        return pagedItems;
      }

      let url = buildBaseUrl(first, last);
      url = appendFiltersToUrl(url, remoteFilters);
      url = appendSortToUrl(url);

      const res = await axios.get(url);
      if (!res.data) {
        return false;
      }

      let ogList = filingListRef.current.map((ele) => ele);
      const locallyFilteredItems = applyClientSideFilters(res.data.items || []);
      await modifyList(locallyFilteredItems, direction, ogList);
      setTotalRecords(res.data.totalItems);

      if (isFilterChange && isFilterChange.length <= 0 &&
        sortingData && sortingData.sortBy === "") {

        if (clientTypeVal === masterTypeVal) {
          setClientTypeVal(res.data.isClientFile)
          setMasterTypeVal(res.data.isMasterFile)
          if (res.data.isClientFile === true && res.data.isMasterFile === true) {
            setIsFilingTypeDisabled(false)
          } else {
            setIsFilingTypeDisabled(true)
          }
        }
        setIsFilingTypeChanged(false)
      }

      return res.data.items;
    } catch (err) {
      // console.log("loadRecordsList err", err);
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      return [];
    } finally {
      if (activeLoadRequestRef.current === requestKey) {
        activeLoadRequestRef.current = "";
      }
    }
  };

  // //maping records for lazy load
  const modifyList = (list, direction, ogList) => {
    // console.log("modifyList", list, direction);
    if (list.length > 0) {
      //list has data
      let awardAgencyLookup = [];
      let awardTypeLookup = [];
      let federalProgramNameLookup = [];
      let stateProgramNameLookup = [];
      let jsicontactNameLookup = [];
      const updList = list.map((item) => {
        const programName = item.programInfo && item.programInfo.length > 0
          ? item.programInfo[0].programName
          : '';
        const businessCategories = Array.isArray(item.businessCategory) ? item.businessCategory : [];
        const federalCategoryNames = businessCategories
          .map((category) => category?.businessCategoryName)
          .filter(Boolean);
        const stateCategoryNames = businessCategories
          .filter((category) => category?.state === item.stateInfo)
          .map((category) => category?.businessCategoryName)
          .filter(Boolean);
        const federalCategoryValue = federalCategoryNames.join(", ");
        const stateCategoryValue = stateCategoryNames.join(", ");

        const awardTypeName = item.awardType && item.awardType.length > 0
          ? item.awardType[0].awardTypeName
          : '';

        const awardingAgencyName = item.awardingAgency && item.awardingAgency.length > 0
          ? item.awardingAgency[0].awardingAgencyName
          : '';

        const jsicontactName = item.jsicontactName ? item.jsicontactName : "";

        //setPostAwardAwardTypeArray([...postawardawardtypeArray,awardTypeName]);
        //setPostAwardAwardingAgencyArray([...postawardawardingagencyArray,awardingAgencyName]);


        // console.log(`postawardagencyArray.includes`, postawardtypeArray.includes(awardTypeName));
        if (!awardTypeLookup.includes(awardTypeName) && awardTypeName !== "") {
          awardTypeLookup.push(awardTypeName)
        }

        if (!jsicontactNameLookup.includes(jsicontactName) && jsicontactName !== "") {
          jsicontactNameLookup.push(jsicontactName)
        }

        if (!awardAgencyLookup.includes(awardingAgencyName) && awardingAgencyName !== "") {
          awardAgencyLookup.push(awardingAgencyName)
        }

        const _stateList = getStateName(item.stateInfo);

        if (item.juristiction?.includes("Federal")) {
          // console.log(`Customers ${item.filingId} cat...`, federalCategoryValue || programName);
          federalCategoryNames.forEach((name) => {
            if (!federalProgramNameLookup.includes(name) && name !== "") {
              federalProgramNameLookup.push(name);
            }
          });

          return { ...item, federalCategories: federalCategoryValue || programName, awardTypeName, awardingAgencyName, jsicontactName };
        } else if (item.juristiction?.includes("Both")) {
          federalCategoryNames.forEach((name) => {
            if (!federalProgramNameLookup.includes(name) && name !== "") {
              federalProgramNameLookup.push(name);
            }
          });

          stateCategoryNames.forEach((name) => {
            if (!stateProgramNameLookup.includes(name) && name !== "") {
              stateProgramNameLookup.push(name);
            }
          });

          return {
            ...item,
            federalCategories: federalCategoryValue || programName,
            stateCategories: stateCategoryValue || programName,
            awardTypeName,
            awardingAgencyName,
            jsicontactName,
            stateList: _stateList
          };
        } else {
          // const categoriesState = item.businessCategory.filter((ele) =>
          //   ele.state ? ele.state === item.stateInfo : ele
          // );
          // console.log(
          //   "stateCategories: filter",
          //   item.filingName,
          //   categoriesState
          // );
          // const categories = categoriesState
          //   .map((ele) => ele.businessCategoryName)
          //   .join(", ");

          stateCategoryNames.forEach((name) => {
            if (!stateProgramNameLookup.includes(name) && name !== "") {
              stateProgramNameLookup.push(name);
            }
          });
          return {
            ...item,
            stateCategories: stateCategoryValue || programName,
            awardTypeName,
            awardingAgencyName,
            jsicontactName,
            stateList: _stateList,
          };
        }
      })

      setPostAwardAgencyArray(awardAgencyLookup);
      setPostAwardTypeArray(awardTypeLookup);
      setPostAwardFederalArray(federalProgramNameLookup);
      setPostAwardStateArray(stateProgramNameLookup);
      setPostAwardJsiContactNameArray(jsicontactNameLookup);

      let tableList = filingListRef.current;
      // console.log("modifyList updCustomers", updList, tableList);

      let updFilingMastersList;
      if (direction === "down") {
        //scroll down
        if (tableList.length >= pageSize * 2) {
          //list >= 2 * pageSize

          //slice 2 half of list
          let unloadList = ogList.slice(
            ogList.length - pageSize,
            ogList.length
          );
          // console.log("modifyList dw unloadList", unloadList);

          //add new data
          updFilingMastersList = [...unloadList, ...updList];
        } else {
          //list < 2 * pageSize

          // add new data to list
          updFilingMastersList = [...ogList, ...updList];
        }
      } else if (direction === "up") {
        //scroll up
        if (tableList.length >= pageSize * 2) {
          //list >= 2 * pageSize

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updList, ...unloadList];
        } else {
          //list < 2 * pageSize

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updList, ...unloadList];
        }
      }

      setUpdatedFilingMasterListSafe(() => updFilingMastersList);
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      return updFilingMastersList;
    } else {
      //list empty
      // console.log("modifyList empty",list)
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      setUpdatedFilingMasterListSafe([]);
      return [];
    }
  };
  // console.log("postawardlist", updatedFilingMasterList);
  const getStateName = (stateCode) => {
    if (stateCode !== null) {
      const state = states.find((s) => s.code === stateCode);
      const stateName = state ? state.state : stateCode;
      return stateName;
    }
    return null
  };

  //table filter change
  const onFilterChange = async (e) => {
    // console.log("onFilterChange props", e.filters);
    let filterChange = [];
    if (e.filters.global.value !== "" && e.filters.global.value !== null) {
      //global filter
      filterChange.push({
        name: `SearchByFilingName`,
        val: e.filters.global.value,
        searchType: `FilingNameSearchType`,
        searchTypeVal: getSearchType("contains"),
      });
    } else {
      //map filter event
      Object.keys(e.filters).forEach((col) => {
        // console.log("onFilterChange col", col, e.filters[col]);
        if (
          e.filters[col].constraints &&
          e.filters[col].constraints[0].value !== null
        ) {
          if (col === "stateList") {
            Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value.map((ele, i) => {
                let changeItem = {
                  name: `SearchByStateInfo`,
                  val: getStateCode(ele),
                };
                if (i + 1 === e.filters[col].constraints[0].value.length) {
                  changeItem.searchType = `StateInfoSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              })
              : filterChange.push({
                name: `SearchByStateInfo`,
                val: getStateCode(e.filters[col].constraints[0].value),
                searchType: `StateInfoSearchType`,
                searchTypeVal: getSearchType(
                  e.filters[col].constraints[0].matchMode
                ),
              });
          } else if (col === "juristiction") {
            filterChange.push({
              name: `SearchByJuristiction`,
              val: e.filters[col].constraints[0].value,
            });
          } else if (col === "required") {
            filterChange.push({
              name: `SearchByRequired`,
              val: e.filters[col].constraints[0].value,
            });
          } else if (
            col === "filingFrequency" &&
            Array.isArray(e.filters[col].constraints[0].value)
          ) {
            e.filters[col].constraints[0].value.forEach((ele, i) => {
              let changeItem = {
                name: `SearchByfilingFrequency`,
                val: ele,
              };
              if (i + 1 === e.filters[col].constraints[0].value.length) {
                changeItem.searchType = `filingFrequencySearchType`;
                changeItem.searchTypeVal = "EqualTo";
              }
              filterChange.push(changeItem);
            });
          } else if (col === "jsicontactName") {
            filterChange.push({
              name: `SearchByJSIStaff`,
              val: e.filters[col].constraints[0].value,
              searchType: `JSIStaffSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "dueDate") {
            filterChange.push({
              name: `SearchByDueDate`,
              val: formatFilterDate(e.filters[col].constraints[0].value),
              searchType: `DueDateSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "awardTypeName") {
            if (Array.isArray(e.filters[col].constraints[0].value)) {
              e.filters[col].constraints[0].value.forEach((ele, i) => {
                let changeItem = {
                  name: `SearchByAwardType`,
                  val: ele,
                };
                if (i + 1 === e.filters[col].constraints[0].value.length) {
                  changeItem.searchType = `AwardTypeSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              });
            } else {
              filterChange.push({
                name: `SearchByAwardType`,
                val: e.filters[col].constraints[0].value,
                searchType: `AwardTypeSearchType`,
                searchTypeVal: getSearchType(
                  e.filters[col].constraints[0].matchMode
                ),
              });
            }
          } else if (col === "awardingAgencyName") {
            if (Array.isArray(e.filters[col].constraints[0].value)) {
              e.filters[col].constraints[0].value.forEach((ele, i) => {
                let changeItem = {
                  name: `SearchByAwardAgency`,
                  val: ele,
                };
                if (i + 1 === e.filters[col].constraints[0].value.length) {
                  changeItem.searchType = `AwardAgencySearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              });
            } else {
              filterChange.push({
                name: `SearchByAwardAgency`,
                val: e.filters[col].constraints[0].value,
                searchType: `AwardAgencySearchType`,
                searchTypeVal: getSearchType(
                  e.filters[col].constraints[0].matchMode
                ),
              });
            }
          } else if (col === "federalCategories") {
            const categoryValues = Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value
              : [e.filters[col].constraints[0].value];
            categoryValues.forEach((ele, i) => {
              // console.log(
              //   "onFilterChange i",
              //   i + 1,
              //   e.filters[col].constraints[0].value.length
              // );
              let changeItem = {
                name: `WhoMustFileFederal`,
                val: ele,
              };
              if (i + 1 === categoryValues.length) {
                changeItem.searchType = `WhoMustFileFederalSearchType`;
                changeItem.searchTypeVal = getSearchType(
                  e.filters[col].constraints[0].matchMode
                );
              }
              filterChange.push(changeItem);
            });
          } else if (col === "stateCategories") {
            const categoryValues = Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value
              : [e.filters[col].constraints[0].value];
            categoryValues.forEach((ele, i) => {
              let changeItem = {
                name: `WhoMustFileInState`,
                val: ele,
              };
              if (i + 1 === categoryValues.length) {
                changeItem.searchType = `WhoMustFileInStateSearchType`;
                changeItem.searchTypeVal = getSearchType(
                  e.filters[col].constraints[0].matchMode
                );
              }
              filterChange.push(changeItem);
            });
          } else {
            filterChange.push({
              name: `SearchBy${col}`,
              val: e.filters[col].constraints[0].value,
              searchType: `${col}SearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          }
        }
      });
    }

    //set filter
    // console.log("onFilterChange filterChange", filterChange);
    handleSetFilterVariable(filterChange);
  };

  const formatFilterDate = (date) => {
    // console.log("formatFilterDate", date);
    let getDate = new Date(date);
    let formatDate = `${getDate.getFullYear()}-${getDate.getMonth() + 1
      }-${getDate.getDate()}`;
    // console.log("formatFilterDate formatDate", getDate.getFullYear(), formatDate);
    return formatDate;
  };

  const getStateCode = (stateName) => {
    // console.log("getStateCode", stateName, states);
    const state = states.find((s) => s.state === stateName);
    return state ? state.code : stateName;
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return matchModeVal.find((ele) => ele.name === matchMode).val;
  };

  const getSortData = (val) => {
    // console.log("getSortData props", val);
    if (val === "dueDate") {
      return {
        SortByParameter: "SortByDuedate",
        SortByVal: "DueDate",
        SortOrderParameter: "SortOrderDuedate"
      }
    } else if (val === "stateList") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "StateInfo",
        SortOrderParameter: "SortOrder"
      }
    } else if (val === "awardTypeName") {
      return {
        SortByParameter: "SortByAwardType",
        SortByVal: "AwardType",
        SortOrderParameter: "SortOrderAwardType"
      }
    } else if (val === "awardingAgencyName") {
      return {
        SortByParameter: "SortByAwardingAgency",
        SortByVal: "AwardingAgency",
        SortOrderParameter: "SortOrderAwardingAgency"
      }
    } else if (val === "federalCategories" || val === "stateCategories") {
      return {
        SortByParameter: "SortByBusinessCategory",
        SortByVal: "BusinessCategory",
        SortOrderParameter: "SortOrderBusinessCategory"
      }
    } else {
      return {
        SortByParameter: `SortBy`,
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        SortOrderParameter: `SortOrder`
      }
    }
  }

  //set filter
  const handleSetFilterVariable = (filterChange) => {
    // console.log("handleSetFilterVariable props", filterChange);
    setIsFilterChange(() => filterChange);
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setUpdatedFilingMasterListSafe([]);
  };

  //table sort change
  const handleSort = async (e) => {
    // console.log("handleSort props",e ,e.sortField)
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
      setRecordsInViewSafe(0);
      setUpdatedFilingMasterListSafe([]);
      setIsLoading(true)
    }
  }

  useEffect(() => {
    // console.log("filter/sort change", isFilterChange, sortingData, !lazyLoading, !refreshRecordList);
    //on filter/sort change
    if (getActiveClientId() && !lazyLoading && !refreshRecordList) {
      const sortAndFilterApiCall = async () => {
        // console.log("LOAD Check 4");
        let records = await loadRecordsList(0, pageSize, "down");
        // console.log("recordsCheck", records);
        setIsLoading(false);
        setRecordsInViewSafe(1)
      };
      sortAndFilterApiCall();
    }
  }, [isFilterChange, sortingData]);

  const handleRefreshList = () => {
    // fetchFilingMasters();
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setUpdatedFilingMasterListSafe([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setMasterCatFilter([]);
    setRefreshRecordList(true);
  }

  const refreshRecords = async () => {
    // console.log("refreshRecords");

    const vScroll = dt.current.getVirtualScroller()

    let range = vScroll.getRenderedRange();
    // console.log("refreshRecords vScroll", vScroll, range);

    let records = await loadRecordsList(0, pageSize, "down");
    if (records) {
      // console.log("refreshRecords refreshDetails", refreshDetails);
      if (refreshDetails?.viewport) {
        // console.log(
        //   "refreshRecords scrollInView",
        //   refreshDetails.viewport.first
        // );
        // vScroll.scrollToIndex(refreshDetails.viewport.first);
      }
      setRecordsInViewSafe(1);
    }
  };

  useEffect(() => {
    // console.log("refreshRecordList,", refreshRecordList, !lazyLoading);
    if (refreshRecordList && !lazyLoading) {
      setLazyLoading(true);
      refreshRecords();
    }
  }, [refreshRecordList]);

  useEffect(() => {
    // console.log("Total Records updated:", totalRecords);
  }, [totalRecords]);

  useEffect(() => {
    // console.log("recordsInView,", recordsInView);
    recordsInViewRef.current = recordsInView;
  }, [recordsInView]);

  useEffect(() => {
    // console.log("pendingTableData,", updatedFilingMasterList);
    filingListRef.current = updatedFilingMasterList;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    updatedFilingMasterList,
    updatedFilingMasterList.length,
    JSON.stringify(updatedFilingMasterList),
  ]);

  useEffect(() => {
    // console.log("isLoading", isLoading);
  }, [isLoading]);

  useEffect(() => {
    // console.log("lazyLoading", lazyLoading);
  }, [lazyLoading]);

  return (
    <Fragment>
      <CustomDialog
        header='Confirmation'
        visible={showAlert}
        onHide={() => closeAlert()}
        onConfirm={() => submitHandler()}
        confirmLabel='Yes'
        cancelLabel='No'
      >
        {alertMessage}
      </CustomDialog>
      {isLoading && (
        <Loader />
      )}

      <style>{`
  .p-datatable.frozen-deffered-pa {
    border-radius: 8px !important;
    overflow: hidden !important;
    border: none !important;
    box-shadow: none !important;
    background: ${tokens.colors.offWhite} !important;
  }

  .frozen-deffered-pa .p-datatable-wrapper {
    border-radius: 8px !important;
    overflow: auto !important;
    height: 550px !important;
    background: ${tokens.colors.offWhite} !important;
  }

  .frozen-deffered-pa .p-datatable-header {
    background: ${tokens.colors.offWhite} !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .frozen-deffered-pa .p-datatable-header .MuiTextField-root .MuiOutlinedInput-notchedOutline {
    border-color: #9ca3af !important;
  }

  .frozen-deffered-pa .p-datatable-header .MuiTextField-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #9ca3af !important;
  }

  .frozen-deffered-pa .p-datatable-header .MuiTextField-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${primaryColor} !important;
    border-width: 2px !important;
  }

  .frozen-deffered-pa .p-datatable-header .MuiTextField-root .MuiOutlinedInput-input {
    color: ${primaryColor} !important;
  }

  .frozen-deffered-pa .p-datatable-table {
    border-radius: 8px !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  /* HEADER */
  .frozen-deffered-pa .p-datatable-thead > tr {
    background: ${primaryColor} !important;
  }

  .frozen-deffered-pa .p-datatable-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px !important;
  }

  .frozen-deffered-pa .p-datatable-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px !important;
  }

  .frozen-deffered-pa .p-datatable-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 8px !important;
  }

  .frozen-deffered-pa .p-datatable-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 8px !important;
  }

  .frozen-deffered-pa .p-datatable-thead > tr > th {
    background: ${primaryColor} !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0.02em !important;
    padding: 10px 10px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-bottom: none !important;
    text-transform: none !important;
    box-shadow: none !important;
    overflow: hidden !important;
  }



  /* Frozen columns z-index fix and dark purple background */
  .frozen-deffered-pa .p-datatable-thead > tr > th.p-frozen-column {
    z-index: 7 !important;
    background: ${primaryColor} !important;
    will-change: auto !important;
  }

  /* Frozen column offsets to match tracker layout */
  .frozen-deffered-pa .p-frozen-column.pa-frozen-select {
    left: 0 !important;
  }

  .frozen-deffered-pa .p-frozen-column.pa-frozen-name {
    left: 2rem !important;
  }

  .frozen-deffered-pa .p-frozen-column.pa-frozen-freq {
    left: 14rem !important;
  }

  .frozen-deffered-pa .p-frozen-column.pa-frozen-state {
    left: 29rem !important;
  }

  .frozen-deffered-pa .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
    z-index: 4 !important;
    background: #ffffff !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-deffered-pa .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
    z-index: 4 !important;
    background: ${tokens.colors.offWhite} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-deffered-pa .p-datatable-tbody > tr > td.p-frozen-column:hover {
    background-color: inherit !important;
    font-weight: inherit !important;
    color: inherit !important;
  }

  .frozen-deffered-pa .p-sortable-column-icon {
    color: #ffffff !important;
  }

  /* ROWS - Alternating colors with gridlines */
  .frozen-deffered-pa .p-datatable-tbody > tr {
    height: 22px !important;
  }

  .frozen-deffered-pa .p-datatable-emptymessage > td {
    height: 40px !important;
    padding: 10px 8px !important;
    line-height: 1.3 !important;
    font-size: 15px !important;
  }

  .frozen-deffered-pa .p-datatable-tbody > tr:nth-child(odd) > td {
    background-color: #ffffff !important;
    padding: 0px 10px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    height: 22px !important;
    min-height: 22px !important;
    max-height: 22px !important;
  }

 .frozen-deffered-pa .p-datatable-tbody > tr:nth-child(even) > td {
    background-color: ${tokens.colors.offWhite} !important;
    padding: 0px 10px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    height: 22px !important;
    min-height: 22px !important;
    max-height: 22px !important;
  }

  /* FORCE PURPLE BORDERS ON ALL CELLS - MUST BE LAST */
  .frozen-deffered-pa .p-datatable-tbody > tr > td {
    border-right: 1px solid ${primaryColor} !important;
    border-bottom: 1px solid ${primaryColor} !important;
    border-left: none !important;
    border-top: none !important;
  }


  .frozen-deffered-pa .p-datatable-tbody > tr > td.p-frozen-column {
    border-right: 1px solid ${primaryColor} !important;
  }

  /* Selection column sizing to match tracker */
  .frozen-deffered-pa .p-datatable-thead > tr > th.p-selection-column,
  .frozen-deffered-pa .p-datatable-tbody > tr > td.p-selection-column {
    width: 2rem !important;
    padding: 0 6px !important;
    text-align: center !important;
  }

  .frozen-deffered-pa .pa-frozen-name {
    padding-left: 8px !important;
  }

  /* First non-frozen column header can get clipped when emptyMessage renders; add a bit of left padding. */
  .frozen-deffered-pa .p-datatable-thead > tr > th.deferred-rule-info-pa {
    padding-left: 18px !important;
  }

/* HOVER - Only for clickable cells (Filing Name) when NOT selected */
.frozen-deffered-pa .p-datatable-tbody > tr:not(.p-highlight) > td.filingNameColumn-pa:hover {
  background-color: color-mix(in srgb, ${primaryColor} 8%, white) !important;
  cursor: pointer !important;
  transition: background-color 0.2s ease;
  border-right: 1px solid ${primaryColor} !important;
  border-bottom: 1px solid ${primaryColor} !important;
}

.frozen-deffered-pa .p-datatable-tbody > tr:not(.p-highlight) > td.filingNameColumn-pa:hover * {
  font-weight: 600 !important;
  color: ${primaryColor} !important;
}

/* Non-clickable cells - no hover effect */
.frozen-deffered-pa .p-datatable-tbody > tr:not(.p-highlight) > td:not(.filingNameColumn-pa):not(.deferred-federal-column-pa):not(.deferred-state-column-pa):hover {
  background-color: inherit !important;
  font-weight: 400 !important;
  border-right: 1px solid ${primaryColor} !important;
  border-bottom: 1px solid ${primaryColor} !important;
}

.frozen-deffered-pa .p-datatable-tbody > tr:not(.p-highlight) > td:not(.filingNameColumn-pa):not(.deferred-federal-column-pa):not(.deferred-state-column-pa):hover * {
  font-weight: 400 !important;
  color: #000000 !important;
}

/* Federal and State columns - only hover on direct cell hover when NOT selected */
.frozen-deffered-pa .p-datatable-tbody > tr:not(.p-highlight) > td.deferred-federal-column-pa:hover,
.frozen-deffered-pa .p-datatable-tbody > tr:not(.p-highlight) > td.deferred-state-column-pa:hover {
  background-color: color-mix(in srgb, ${primaryColor} 8%, white) !important;
  cursor: pointer !important;
}

.frozen-deffered-pa .p-datatable-tbody > tr:not(.p-highlight) > td.deferred-federal-column-pa:hover *,
.frozen-deffered-pa .p-datatable-tbody > tr:not(.p-highlight) > td.deferred-state-column-pa:hover * {
  font-weight: 600 !important;
  color: ${primaryColor} !important;
}

 /* SELECTED ROW */
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight:nth-child(odd) > td,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight:nth-child(even) > td,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td.p-frozen-column,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight:nth-child(odd) > td.p-frozen-column,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight:nth-child(even) > td.p-frozen-column {
    background-color: color-mix(in srgb, ${primaryColor} 14%, white) !important;
    border-right: 1px solid ${primaryColor} !important;
    border-bottom: 1px solid ${primaryColor} !important;
  }

  /* After selection, remove hover effects on cells */
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight:hover,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight:hover > td,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td:hover,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td.p-frozen-column:hover,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td.filingNameColumn-pa:hover,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td.deferred-federal-column-pa:hover,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td.deferred-state-column-pa:hover {
    background-color: color-mix(in srgb, ${primaryColor} 14%, white) !important;
  }

  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td:hover *,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td.filingNameColumn-pa:hover *,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td.deferred-federal-column-pa:hover *,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight > td.deferred-state-column-pa:hover *,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight:hover > td.deferred-federal-column-pa *,
  .frozen-deffered-pa .p-datatable-tbody > tr.p-highlight:hover > td.deferred-state-column-pa * {
    font-weight: inherit !important;
  }

  .frozen-deffered-pa .p-selection-column .p-radiobutton {
    display: flex !important;
    justify-content: center !important;
    margin: 0 auto !important;
  }

  .frozen-deffered-pa .p-selection-column .p-radiobutton .p-radiobutton-box {
    border: 2px solid ${primaryColor} !important;
  }

  .frozen-deffered-pa .p-selection-column .p-radiobutton .p-radiobutton-box.p-highlight,
  .p-radiobutton .p-radiobutton-box.p-highlight {
    border-color: ${primaryColor} !important;
    background: ${primaryColor} !important;
  }

  .frozen-deffered-pa .p-selection-column .p-radiobutton:not(.p-radiobutton-disabled) .p-radiobutton-box:hover,
  .p-radiobutton:not(.p-radiobutton-disabled) .p-radiobutton-box:hover {
    border-color: ${primaryColor} !important;
  }

  .p-radiobutton:not(.p-radiobutton-disabled) .p-radiobutton-box.p-focus {
    box-shadow: 0 0 0 0.2rem ${primaryColor}33 !important;
    border-color: ${primaryColor} !important;
  }

  /* SCROLLBAR */
  .p-datatable-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb {
    background: #C0BEC2;
    border-radius: 10px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
    background: ${primaryColor};
  }

  .deferred-categories-overlay .p-overlaypanel-close {
    background: ${primaryColor} !important;
    border: 1px solid ${primaryColor} !important;
    border-radius: 999px !important;
  }

  .deferred-categories-overlay .p-overlaypanel-close-icon,
  .deferred-categories-overlay .p-overlaypanel-close .pi,
  .deferred-categories-overlay .p-overlaypanel-close svg {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  .deferred-more-count {
    color: #9ca3af !important;
    font-size: 12px !important;
    margin-left: 6px !important;
    text-decoration: none !important;
  }
`}</style>


      <div style={{ padding: "0 16px 12px" }}>
        <DataTable
          ref={dt}
          key="list"
          value={updatedFilingMasterList}
          emptyMessage='No records found'
          scrollable
          className="frozen-deffered-pa"
          style={{ borderRadius: '8px', overflow: 'hidden', border: 'none', background: tokens.colors.offWhite, width: "100%" }}
          selectionMode="radiobutton"
          selection={selectedMasters}
          onSelectionChange={(e) => {
            // console.log("##Selected: ", e.value);
            persistSelectedDeferredRow(e.value);
            setSelectedMasters(e.value);
            props.changeSelectedMasters(e.value)
          }}
          onRowToggle={(e) => rowExpand(e)}
          expandedRows={expandedRows}
          dataKey='rowNumber'
          onRowSelect={onRowSelect}
          globalFilterFields={["filingName"]}
          header={renderHeader()}
          virtualScrollerOptions={{
            onScroll: loadDataLazy,
            itemSize: 28,
            delay: 0,
            scrollHeight: "550px",
            appendOnly: true,
          }}
          scrollHeight="550px"
          sortField={sortingData.sortBy}
          sortOrder={sortingData.sortOrder}
          onSort={(e) => handleSort(e)}
          tableStyle={{ minWidth: "100%" }}
        >
          <Column
            selectionMode="single"
            frozen={enableForzen}
            headerStyle={{ width: "2rem" }}
            style={{ width: "2rem", margin: "0" }}
            headerClassName="pa-frozen-select"
            className="pa-frozen-select"
          >
            Select
          </Column>

          <Column
            field='filingName'
            header='Filing Name'
            frozen={enableForzen}
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            className="filingNameColumn-pa pa-frozen-name"
            headerClassName="pa-frozen-name"
            style={{ minWidth: "12rem", maxWidth: "25rem" }}
            body={(rowData) => cellListDisplayName(rowData)}
          ></Column>

          <Column
            field='filingFrequency'
            header='Filing Frequency'
            frozen={enableForzen}
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            className="pa-frozen-freq"
            headerClassName="pa-frozen-freq"
            style={{ minWidth: "15rem" }}
            body={(rowData) => cellWithTooltip(rowData, 'filingFrequency')}
          ></Column>

          <Column
            field='stateList'
            header='State'
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            frozen={enableForzen}
            className="pa-frozen-state"
            headerClassName="pa-frozen-state"
            style={{ minWidth: "13rem" }}
            body={(rowData) => cellWithTooltip(rowData, 'stateList')}
          />
          <Column
            field='ruleInfo'
            header='Rule Info'
            style={{ minWidth: "15rem", maxWidth: "15rem" }}
            className="deferred-rule-info-pa"
            headerClassName="deferred-rule-info-pa"
            body={(rowData) => cellListDisplayRuleInfo(rowData)}
          ></Column>
          {/* <Column
              field='federalCategories'
              header='Who must File Federal'
              // body={(rowData) =>
              //   CellListDisplayFederal(rowData, "federalCategories")
              // }


              style={{ minWidth: "15rem", maxWidth: "15rem" }}
            ></Column> */}
          <Column
            field="federalCategories"
            header="Who Must File in Federal"
            style={{ minWidth: "18rem", maxWidth: "18rem" }}
            className="deferred-federal-column-pa"
            bodyClassName="deferred-federal-column-pa"
            body={(rowData) => CellListDisplayFederal(rowData, "federalCategories")}
          ></Column>
          {/* <Column
              field='stateCategories'
              header='Who Must File in State'
              // body={(rowData) =>
              //   CellListDisplayFederal(rowData, "stateCategories")
              // }
              style={{ minWidth: "15rem", maxWidth: "15rem" }}
            ></Column> */}
          <Column
            field="stateCategories"
            header="Who Must File in State"
            style={{ minWidth: "18rem", maxWidth: "18rem" }}
            className="deferred-state-column-pa"
            bodyClassName="deferred-state-column-pa"
            body={(rowData) => CellListDisplayFederal(rowData, "stateCategories")}
          ></Column>
          <Column
            field="juristiction"
            header="Jurisdiction"
            style={{ minWidth: "14rem" }}
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            body={(rowData) => cellWithTooltip(rowData, 'juristiction')}
          ></Column>
          {/* <Column
            field="notes"
            header="Notes"
            style={{ minWidth: "21rem", maxWidth: "21rem" }}
          // body={(rowData) => cellListDisplayNotes(rowData)}
          ></Column> */}
          <Column
            field='required'
            header='Required'
            style={{ minWidth: "13rem" }}
            className='column-small'
            body={(rowData) => cellWithTooltip(rowData, 'required')}
          >
            Select
          </Column>
          {/* <Column
            field='jsidept'
            header='JSI Dept'
            style={{ minWidth: "14rem" }}
          ></Column> */}
          {/* <Column
              field='jsiContactEmail'
              header='PostAward POC'
              style={{ minWidth: "14rem" }}
            ></Column> */}
          <Column
            field="jsicontactName"
            header="PostAward POC"
            style={{ minWidth: "18rem", maxWidth: "18rem" }}
            body={(rowData) => cellWithTooltip(rowData, 'jsicontactName')}
          ></Column>
          {/* <Column
              field='awardTypeName'
              header='Award Type'
              style={{ minWidth: "14rem" }}
            ></Column> */}
          <Column
            field="awardTypeName"
            header="Award Type"
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            style={{ minWidth: "18rem", maxWidth: "18rem" }}
            body={(rowData) => cellWithTooltip(rowData, 'awardTypeName')}
          ></Column>
          {/* <Column
              field='awardingAgencyName'
              header='Awarding Agency'
              style={{ minWidth: "14rem" }}
            ></Column> */}
          <Column
            field="awardingAgencyName"
            header="Award Agency"
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            style={{ minWidth: "18rem", maxWidth: "18rem" }}
            body={(rowData) => cellWithTooltip(rowData, 'awardingAgencyName')}
          ></Column>
          {/* <Column
            field='jsiContactEmail'
            header='JSI Contact Email'
            style={{ minWidth: "14rem" }}
          ></Column> */}
        </DataTable>
      </div>
      <CustomDialog
        header={dialogTitle}
        visible={openDialog}
        onHide={() => setOpenDialog(false)}
      >
        {dialogMessage}
      </CustomDialog>
      <ClientTableFilter
        anchorEl={filterAnchorEl}
        onClose={handleFilterClose}
        onApply={handleFilterApply}
        onClear={handleFilterClear}
        clients={updatedFilingMasterList}
        categoriesLookup={categoryList}
        programList={[]}
        stateList={stateArray}
        tracknowlicenseTypes={[]}
        postawardlicenseTypes={[]}
        roleType={""}
        awardTypeList={postawardtypeArray}
        awardAgenciesList={postawardagencyArray}
        postAwardPocList={postawardjsicontactnameArray}
        postAwardDeferredMode={true}
        requiredOnlyIs={true}
        singleSelectColumnsByMatchMode={{
          stateList: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_CONTAINS],
          federalCategories: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_CONTAINS],
          stateCategories: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_CONTAINS],
          awardTypeName: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_CONTAINS],
          awardingAgencyName: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_CONTAINS]
        }}
        filterOptionsByColumn={{
          juristiction: [{ value: FilterMatchMode.EQUALS, label: "Is" }]
        }}
      />
    </Fragment>
  );
};

export default AddFilingPostAwardtable;

